import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { FaExternalLinkAlt } from "react-icons/fa";
import { BACKEND } from "../config/configEnvs";

function Contabilidad() {
  const [contabilidad, setContabilidad] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupContent, setPopupContent] = useState(null);

  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    const fetchContabilidad = async () => {
      try {
        const response = await axios.get(`${BACKEND}/api/contabilidad`, {
          params: {
            limit: 1000,
          },
        });
        const data = response.data.docs;
        const filteredContabilidad = data.filter((contabilidad) => {
          if (!contabilidad.access || contabilidad.access.length === 0) {
            return true;
          } else {
            return contabilidad.access.some(
              (access) => access.subarea === user.subarea
            );
          }
        });

        setContabilidad(filteredContabilidad);
      } catch (error) {
        console.log(error);
      }
    };

    fetchContabilidad();
  }, [user.subarea]);

  const togglePopup = (contabilidad) => {
    if (contabilidad) {
      if (contabilidad.popup) {
        setShowPopup(!showPopup);
        setPopupContent(contabilidad);
      } else {
        window.open(contabilidad.link, "_blank");
      }
    } else {
      setShowPopup(false);
      setPopupContent(null);
    }
  };

  const handleCopyToClipboard = (text, elemento) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    elemento.showCopiedAlert = true;
    setPopupContent({ ...popupContent });
    setTimeout(() => {
      elemento.showCopiedAlert = false;
      setPopupContent({ ...popupContent });
    }, 2000);
  };

  return (
    <div className="w-full flex flex-col">
      <h1 className="mx-auto text-3xl lg:text-4xl font-bold mt-4 mb-12">
        Contabilidad
      </h1>
      <div className="flex flex-col max-w-7xl mx-auto md:grid md:grid-cols-3 lg:grid-cols-4 px-8">
        {contabilidad.map((contabilidad) => {
          return (
            <div key={contabilidad.id} className="w-full mb-8 md:px-6">
              <button
                className="flex flex-col bg-zinc-800 text-white shadow-md shadow-black rounded-3xl mx-auto cursor-pointer h-full"
                onClick={() => togglePopup(contabilidad)}
              >
                <h2 className="text-center px-4 my-6 text-lg font-bold uppercase">
                  {contabilidad.name}
                </h2>
                <div className="mx-auto h-48">
                  <div
                    className="rounded-[20%] overflow-hidden h-full w-full border-[1px] border-zinc-700"
                    style={{
                      width: "200px",
                      height: "200px",
                    }}
                  >
                    <div className="flex w-full h-full items-center justify-center">
                      <img src={contabilidad.img} alt="" />
                    </div>
                  </div>
                </div>
                <p className="mx-auto text-center px-2 my-6 md:text-base flex items-center">
                  {contabilidad.descripcion}
                </p>
              </button>
            </div>
          );
        })}
      </div>

      {showPopup && popupContent && (
        <div className="fixed z-[1000] top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex items-center justify-center">
          <div
            className="bg-white p-4 rounded-lg"
            style={{ maxHeight: "85vh", overflowY: "auto" }}
          >
            <div className="text-black flex items-center p-2 rounded-t-lg w-full">
              <h3 className="mx-12 text-lg text-center font-semibold">
                {popupContent.name}
              </h3>
              <button
                className="absolute mr-0 flex font-extrabold p-2"
                onClick={() => togglePopup(null)}
              >
                X
              </button>
            </div>

            {popupContent.elemento.map((elemento) => (
              <div key={elemento.id}>
                <div className="bg-white text-black p-2">
                  {elemento.user && elemento.password && (
                    <div>
                      <h2 className="my-2">
                        Usuario:{" "}
                        <span
                          className="font-bold cursor-pointer"
                          onClick={() =>
                            handleCopyToClipboard(elemento.user, elemento)
                          }
                        >
                          {elemento.user}
                        </span>
                      </h2>
                      <h2 className="my-2">
                        Contraseña:{" "}
                        <span
                          className="font-bold cursor-pointer"
                          onClick={() =>
                            handleCopyToClipboard(elemento.password, elemento)
                          }
                        >
                          {elemento.password}
                        </span>
                      </h2>
                    </div>
                  )}
                  {elemento.showCopiedAlert && (
                    <div className="text-green-500 mt-2">
                      Copiado al portapapeles
                    </div>
                  )}
                </div>
                <a
                  className="w-auto flex justify-center items-center"
                  href={elemento.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={elemento.id}
                >
                  <button className="flex items-center justify-center mx-auto bg-[#ff6400] text-white px-4 py-2 rounded-xl mb-2">
                    <span>{elemento.title}</span>
                    <FaExternalLinkAlt className="ml-2" />
                  </button>
                </a>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default Contabilidad;
